/**
 * SignUp Feature Routes
 */

import type { RouteRecordRaw } from 'vue-router';

export const signUpRoutes: RouteRecordRaw[] = [
  {
    path: '/signup',
    name: 'SignUp',
    component: () => import('./views/SignUpPage.vue'),
    meta: {
      title: 'signUp.Create Account',
      requiresAuth: false,
      layout: 'blank',
    },
  },
  {
    path: '/signup/complete',
    name: 'SignUpComplete',
    component: () => import('./views/SignUpCompletePage.vue'),
    meta: {
      title: 'signUp.registrationComplete',
      requiresAuth: false,
      layout: 'blank',
    },
  },
  {
    path: '/signup/invite/:linkCode',
    name: 'SignUpInvite',
    component: () => import('./views/SignUpPage.vue'),
    meta: {
      title: 'signUp.Create Account',
      requiresAuth: false,
      layout: 'blank',
    },
    props: (route) => ({
      inviteLinkCode: route.params.linkCode as string,
    }),
  },
];

